
export const findPermission = (array: any, permission: any) => {
  const find = array.find((item) => item === permission);
  if (find) {
    return true;
  } else {
    return false;
  }
};

// ["employee","manager","admin"]
